module.exports = {"id":"226807","name":"Cristian Roldan","rating":"73","photo":"./data/images/photos/3/226807.png","club":{"name":"Seattle Sounders","logo":"./data/images/clubs/SeattleSounders.png"},"positions":["MDC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CristianRoldan0.json
// module id = 881
// module chunks = 0